<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="toc"><a id="page5"></a><a id="page6"></a><em>contents</em></h1>
<p class="toc2"><a class="hlink" href="#/OEBPS/tp.htm">Title Page</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/pro.htm#pro" id="pro"><em>Prologue: The Secret</em></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/part1.htm#part1" id="part1"><strong>part one</strong></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/part1.htm#part1"><em>darkness falls</em></a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch1.htm#ch1" id="ch1">1. The Call</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch2.htm#ch2" id="ch2">2. Invasion</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch3.htm#ch3" id="ch3">3. Threshold</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/part2.htm#part2" id="part2"><strong>part two</strong></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/part2.htm#part2"><em>night vision</em></a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch4.htm#ch4" id="ch4">4. The Milkman’s Daughter</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch5.htm#ch5" id="ch5">5. The Promise</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch6.htm#ch6" id="ch6">6. The Canvas</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch7.htm#ch7" id="ch7">7. Mosaic</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch8.htm#ch8" id="ch8">8. The Holy Exchange</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch9.htm#ch9" id="ch9">9. The Wait</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch10.htm#ch10" id="ch10">10. Wall of Grace</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/part3.htm#part3" id="part3"><strong>part three</strong></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/part3.htm#part3"><em>dawn’s light</em></a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch11.htm#ch11" id="ch11">11. Home Fires</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch12.htm#ch12" id="ch12">12. Tapestry</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch13.htm#ch13" id="ch13">13.	Breakthrough</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch14.htm#ch14" id="ch14">14. The Giving Tree</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch15.htm#ch15" id="ch15">15. Whispers and Shouts</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch16.htm#ch16" id="ch16">16. Laughter</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch17.htm#ch17" id="ch17">17. The Basket</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch18.htm#ch18" id="ch18">18. The Question</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch19.htm#ch19" id="ch19">19. Seven Candles</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch20.htm#ch20" id="ch20">20. Release</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ch21.htm#ch21" id="ch21">21. Father of Light</a></p>
<p class="toc3"><a class="hlink" href="#/OEBPS/ack.htm#ack" id="ack"><em>Acknowledgments</em></a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/ata.htm#ata" id="ata">About the Authors</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/cop.htm" id="cop">Copyright</a></p>
<p class="toc2"><a class="hlink" href="#/OEBPS/atp.htm#atp" id="atp">About the Publisher</a></p>
<a id="page7"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?963050a8